export default __webpack_public_path__ + "static/media/by_0.45526fa1.mp3";